import { render, staticRenderFns } from "./AlisonLibComponent.vue?vue&type=template&id=2fb04c27&scoped=true"
import script from "./AlisonLibComponent.vue?vue&type=script&lang=js"
export * from "./AlisonLibComponent.vue?vue&type=script&lang=js"
import style0 from "./AlisonLibComponent.vue?vue&type=style&index=0&id=2fb04c27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb04c27",
  null
  
)

export default component.exports